export default __webpack_public_path__ + "static/media/teams-icon.10f559c4.svg";